import React, { useState } from "react";
import { Tabs, Tab, Box } from "@material-ui/core";
import { ActionPermissionsGroupTab } from "./ActionPermissionsGroupTab";
import { useTranslate } from "react-admin";
import { RootActionPermissionGroup } from "../../../../common/data/service-proxies";

interface ActionPermissionsTabProps {
  permissionDefinitions: RootActionPermissionGroup[];
}

interface TabPanelProps {
  children?: React.ReactNode;
  index: any;
  value: any;
}

const TabPanel = (props: TabPanelProps) => {
  const { children, value, index, ...other } = props;
  return (
    <div role="tabpanel" hidden={value !== index} {...other}>
      <Box>{children}</Box>
    </div>
  );
};

export const InnerActionPermissionsTab = ({
  permissionDefinitions,
  ...rest
}: ActionPermissionsTabProps) => {
  const translate = useTranslate();
  const [selectedTab, setSelectedTab] = useState(0);
  const handleChange = (_: React.ChangeEvent<{}>, newValue: number) => {
    setSelectedTab(newValue);
  };

  return (
    <>
      <Tabs
        value={selectedTab}
        onChange={handleChange}
        variant="scrollable"
        scrollButtons="auto"
        indicatorColor="primary"
        textColor="primary"
      >
        {permissionDefinitions.map((permissionGroup, permissionGroupIndex) => {
          if (!permissionGroup?.group) {
            return null;
          }

          return (
            <Tab
              key={permissionGroupIndex}
              label={translate(
                `permissions.${permissionGroup.group.displayName}`
              )}
            />
          );
        })}
      </Tabs>
      {permissionDefinitions.map((group, permissionGroupIndex) => {
        if (!group) {
          return null;
        }

        return (
          <TabPanel
            key={permissionGroupIndex}
            value={selectedTab}
            index={permissionGroupIndex}
          >
            <ActionPermissionsGroupTab group={group} {...rest} />
          </TabPanel>
        );
      })}
    </>
  );
};
